import React, { Component } from 'react';
import './notifications.scss';

import Notification from './Notification';
import { joinClasses } from '../../../utils/helpers';
import closeIcon from '../../../assets/images/close-white.svg';

/** @import {NotificationsProps} from './NotificationTypes' */

/** @extends {Component<NotificationsProps>} */
class Notifications extends Component {

  /** @type {React.RefObject<HTMLDivElement>} */
  elementRef = React.createRef();

  componentDidMount() {
    document.body.addEventListener('click', this.onClickOutside, false);
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.onClickOutside);
  }

  onClickOutside = (/** @type {MouseEvent} */ event) => {
    if (
      this.props.open && 
      this.elementRef.current && 
      // @ts-expect-error may have the types wrong
      !this.elementRef.current.contains(event.target)
    ) {
      event.preventDefault();
      event.stopPropagation();
      if (this.props.onClose) this.props.onClose();
    }
  }

  render() {
    const { onClose, open, notifications, removeNotification } = this.props;

    return (
      <div ref={this.elementRef} className={joinClasses('notifications', open ? 'notifications--open' : '')}>
        <div className="notifications__header">
          <h2 className="notifications__title">Notifications</h2>
          <img src={closeIcon} className="notifications__close" onClick={onClose} />
        </div>
        <div className={joinClasses("notifications__content", notifications.length <= 0 ? "notifications__content--empty" : '')}>
          {notifications.length <= 0 && <div className="notifications__empty">You have no new notifications</div>}
          {notifications.map(notification => (
            <Notification key={notification.id} notification={notification} onDismiss={removeNotification} />
          ))}
        </div>
      </div>
    );
  }
}

export default Notifications;
